import { render, staticRenderFns } from "./PanelEditor.vue?vue&type=template&id=05a3dc02&scoped=true"
import script from "./PanelEditor.vue?vue&type=script&lang=ts"
export * from "./PanelEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a3dc02",
  null
  
)

export default component.exports